__turbopack_context__.v({
  "active": "LargePromptCard-module__p7aUdq__active",
  "checkmark": "LargePromptCard-module__p7aUdq__checkmark",
  "container": "LargePromptCard-module__p7aUdq__container",
  "content": "LargePromptCard-module__p7aUdq__content",
  "content-wrapper": "LargePromptCard-module__p7aUdq__content-wrapper",
  "declineButton": "LargePromptCard-module__p7aUdq__declineButton",
  "disclaimer": "LargePromptCard-module__p7aUdq__disclaimer",
  "disclaimer-text": "LargePromptCard-module__p7aUdq__disclaimer-text",
  "label": "LargePromptCard-module__p7aUdq__label",
  "list": "LargePromptCard-module__p7aUdq__list",
  "paddingTop": "LargePromptCard-module__p7aUdq__paddingTop",
  "price": "LargePromptCard-module__p7aUdq__price",
  "promptButton": "LargePromptCard-module__p7aUdq__promptButton",
  "save-tag": "LargePromptCard-module__p7aUdq__save-tag",
  "title": "LargePromptCard-module__p7aUdq__title",
  "title-bar": "LargePromptCard-module__p7aUdq__title-bar",
});
